/*
 * @Author: bbqin
 * @Date: 2022-08-11 10:32:18
 * @LastEditTime: 2022-08-11 10:39:56
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\FastExtend\utilities.js
 * (混沌)足够多的方案才能接近真实的结果。
 */

/**
 * 判断对象类型
 * @param {*} origin 
 * @returns 
 */
export function getObjectType(origin) {
    return Object.prototype.toString.call(origin).slice(8, -1);
}

/**
 * 是不是异步
 * @param {*} obj 
 * @returns 
 */
export const isPromise = function (obj) {
    return obj && getObjectType(obj) === 'Promise';
};

/**
 * 是不是异步方法
 * @param {*} obj 
 * @returns 
 */
export const isAsyncFunction = function (obj) {
    return obj && getObjectType(obj) === 'AsyncFunction';
};

/**
 * 是不是数组
 * @param {*} obj 
 * @returns 
 */
export const isArray = function (obj) {
    return obj && getObjectType(obj) === 'Array';
};

/**
 * 是不是方法
 * @param {*} obj 
 * @returns 
 */
export const isFunction = function (obj) {
    return obj && typeof obj === "function";
};